import { Eye, Paperclip } from 'lucide-react';

import type { TFunction } from 'i18next';

import type { ReceiveHistoryTableData } from '@/entities/receive';
import type { TableAction } from '@/shared/ui/data-table';

interface BuildReceiveHistoryRowActionsArgs {
  onShowDisposition: (consignmentId: string) => void;
  /** Receives the receipt's own shipment id — the upload endpoint takes no other. */
  onAddAttachment: (shipmentId: string) => void;
  t: TFunction;
}

/**
 * Per-row actions for the receive history table: the consignment's Line
 * Disposition dialog, and the port of the legacy tab's add-attachment dialog for
 * documents that turn up after the receipt was recorded.
 */
export function buildReceiveHistoryRowActions({
  onShowDisposition,
  onAddAttachment,
  t
}: BuildReceiveHistoryRowActionsArgs): TableAction<ReceiveHistoryTableData>[] {
  return [
    {
      id: 'show-disposition',
      label: t('cmrlist.showdisposition.label', 'Show Disposition'),
      icon: Eye,
      onClick: (row) => onShowDisposition(row.consignmentId)
    },
    {
      id: 'add-attachment',
      label: t('newcmr.add.attachment.label', 'Upload attachment'),
      icon: Paperclip,
      intent: 'document',
      onClick: (row) => onAddAttachment(row.shipmentId)
    }
  ];
}
